import BreadcrumbList from '@/utils/breadcrumb'
import { make } from 'vuex-pathify'

const state = {
  items: []
}

const mutations = {
  ...make.mutations(state),

  PUSH_ITEM: (state, item) => {
    state.items.push(item)
  },

  POP_ITEM: (state) => {
    state.items.pop()
  },
  /**
   * payload: {
   *  find: 'item code',
   *  replace: obj item
   * }
   */
  REPLACE_ITEM: (state, payload) => {
    const index = state.items.findIndex((breadcrumb) => {
      return breadcrumb.code === payload.find
    })
    if (index) {
      state.items.splice(index, 1, payload.replace)
    }
  }
}

const getParentBreadcrumbs = async (arr = [], breadcrumb) => {
  if (!breadcrumb) {
    return arr
  }
  if (breadcrumb.items) {
    arr = [...arr, ...breadcrumb.items]
  }
  if (breadcrumb.parent && BreadcrumbList[breadcrumb.parent]) {
    arr = await getParentBreadcrumbs(arr, BreadcrumbList[breadcrumb.parent])
  }
  return arr
}

const actions = {
  ...make.actions(state),
  push({ commit }, payload) {
    commit('PUSH_ITEM', payload)
  },
  pop({ commit }) {
    commit('POP_ITEM')
  },
  replace({ commit }, payload) {
    commit('REPLACE_ITEM', payload)
  },
  empty({ commit }, payload) {
    commit('SET_ITEMS', [])
  },
  async set({ commit }, payload) {
    let breadcrumbs = []
    const currentBreadcrumb = BreadcrumbList[payload]
    if (currentBreadcrumb) {
      breadcrumbs = await getParentBreadcrumbs(breadcrumbs, currentBreadcrumb)
    }
    commit('SET_ITEMS', breadcrumbs.reverse())
  }
}

const getters = {
  items: (state) => {
    return state.items
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
